import { Flex } from "@itandi/itandi-bb-ui/Flex";
import type React from "react";
import type { DealConstructionContext } from "~/models/DealConstruction";
import { isDealBillingContext } from "~/models/DealConstruction";
import { toThousandSeparator } from "~/utils/CurrencySeparator";
import Styles from "./ConstructionTop.module.scss";

type Props = {
	billingTarget?: "owner" | "rentee" | null;
	constructionContext: DealConstructionContext;
	dealEstimationDraftHeader?: DealConstructionContext | null;
	dealEstimationHistoryContext?: DealConstructionContext | null;
	ownManagement?: boolean;
};

export const ConstructionAmounts: React.FC<Props> = ({
	constructionContext,
	dealEstimationHistoryContext = null,
	dealEstimationDraftHeader = null,
	billingTarget = null,
	ownManagement = false
}: Props) => {
	const { totalAmount, totalAmountWithTax } = constructionContext;
	const showSettlementInformation =
		isDealBillingContext(constructionContext) &&
		constructionContext.dealSettlements.length > 0;
	const showEstimationHistory = dealEstimationHistoryContext && !ownManagement;
	const totalAmountLabel = ((): string => {
		if (billingTarget) return "施工項目総額";
		if (showEstimationHistory) return "申請前総額";
		return "総額";
	})();
	const getTotalAmountWithTax = ((): number => {
		// 非共有案件に申請前、申請後という概念は存在しないので、常に最新の見積り額を表示する
		if (
			dealEstimationDraftHeader &&
			dealEstimationDraftHeader.totalAmountWithTax !== 0 &&
			ownManagement
		) {
			return dealEstimationDraftHeader.totalAmountWithTax;
		}
		return totalAmountWithTax;
	})();
	const getTotalAmount = ((): number => {
		if (
			dealEstimationDraftHeader &&
			dealEstimationDraftHeader.totalAmount !== 0 &&
			ownManagement
		) {
			return dealEstimationDraftHeader.totalAmount;
		}
		return totalAmount;
	})();
	return (
		<Flex direction="column" gap="8px">
			{showSettlementInformation ? (
				<div className={Styles.Amounts}>
					<span className={Styles.TotalAmount}>
						精算項目総額：¥
						{toThousandSeparator(
							billingTarget === "owner"
								? constructionContext.settlementOwnerTotalAmountWithTax
								: constructionContext.settlementRenteeTotalAmountWithTax
						)}
					</span>
					<span className={Styles.TotalAmountWithoutTax}>
						税抜：¥
						{toThousandSeparator(
							billingTarget === "owner"
								? constructionContext.settlementOwnerTotalAmount
								: constructionContext.settlementRenteeTotalAmount
						)}
					</span>
				</div>
			) : null}
			<Flex direction="column" gap="8px">
				{showEstimationHistory ? (
					<div className={Styles.Amounts}>
						<span className={Styles.TotalAmount}>
							申請後総額：¥
							{toThousandSeparator(
								dealEstimationHistoryContext.totalAmountWithTax
							)}
						</span>
						<span className={Styles.TotalAmountWithoutTax}>
							税抜：¥
							{toThousandSeparator(dealEstimationHistoryContext.totalAmount)}
						</span>
					</div>
				) : null}
				<div className={Styles.Amounts}>
					<span className={Styles.TotalAmount}>
						{totalAmountLabel}：¥
						{toThousandSeparator(getTotalAmountWithTax)}
					</span>
					<span className={Styles.TotalAmountWithoutTax}>
						税抜：¥
						{toThousandSeparator(getTotalAmount)}
					</span>
				</div>
			</Flex>
		</Flex>
	);
};
